// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === UserPayslip.css === */
 
.payslip-container {
  padding: 20px;
  font-family: "Poppins", sans-serif;
  background: #f8f9fa;
  min-height: 100vh;
}
 
.payslip-title {
  text-align: center;
  margin-bottom: 20px;
  color: #004c3f;
  font-weight: 600;
}

.user-payslip-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}

.user-payslip-header .payslip-title {
  margin: 0;
}

.download-all-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 38px;
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  background: rgb(132, 199, 174);
  color: #ffffff;
  cursor: pointer;
  font-weight: 600;
}

.download-all-btn:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.payslip-label {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-right: 10px;
}

.payslip-label-select {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.payslip-select {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: white;
  outline: none;
  cursor: pointer;
  transition: 0.2s ease;
}
 
.payslip-select:hover {
  border-color: #007b55;
}
 
.month-list {
  height: 370px; 
  width: 350px;  
  margin-top: 15px;
  overflow-y: auto; /* vertical scroll */
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* left align */
  padding: 10px;
  background: #fff; /* optional: box background */
  border-radius: 6px; /* rounded corners */
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1); /* subtle shadow */
}
.month-list::-webkit-scrollbar {
  display: none;
}
 
.month-row {
  width: 300px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 6px;
  border-bottom: 1px solid #e0e0e0;
  background: #fff;
  border-radius: 6px;
  margin-bottom: 6px;
  font-size: 14px;
  transition: all 0.2s ease;
}
 
.month-row:hover {
  background: #e9f6f1;
}
 
.month-name {
  font-weight: 600;
  color: #222;
}
 
.salary-amount {
  color: #666;
  font-size: 14px;
}
 
.icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  margin-left: 10px;
  transition: transform 0.2s ease;
}
 
.icon-btn:hover {
  transform: scale(1.2);
}

.user-payslip-table-container {
  width: 100%;
  overflow-x: auto;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.user-payslip-table {
  width: 100%;
  min-width: 780px;
  border-collapse: collapse;
}

.user-payslip-table th,
.user-payslip-table td {
  border-bottom: 1px solid #e7e7e7;
  text-align: left;
  padding: 10px;
    height: 36px;
    font-size: 12px;
}


.user-payslip-table th {
  background: #d8f3d8;
  /* color: #004c3f; */
  font-weight: 600;
  font-size: 12px;
}

.user-payslip-table td[colspan] {
  text-align: center;
  color: #666;
}

.user-payslip-table .action {
  white-space: nowrap;
}
 
/* === Overlay === */
.overlay {
  position: fixed;
    top: 13vh;
    left: 38vw;
  /* width: 100vw;
  height: 100vh; */
  background-color: white;
  display: flex;
  justify-content: center; /* ✅ center horizontally */
  align-items: center; /* ✅ center vertically */
  z-index: 99;
  padding: 10px;
}

.payslip-hidden-capture {
  position: fixed;
  top: 0;
  left: -10000px;
  width: 760px;
  background: #fff;
  pointer-events: none;
}

.payslip-capture-wrapper {
  background: #fff;
}
 
/* === Modal === */
.modal-box {
  background: #fff;
  /* padding: 25px; */
  border-radius: 12px;
  /* width: 420px; */
  position: relative;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  animation: fadeIn 0.3s ease;
}
 
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
 
.close-btn {
  /* position: absolute; */
  top: 8px;
  right: 12px;
  cursor: pointer;
  border: none;
  background: none;
  font-size: 18px;
  color: #333;
  transition: 0.2s ease;
}
 
.close-btn:hover {
  color: #d00000;
}
 
.modal-box h3 {
  text-align: center;
  color: #004c3f;
  margin-bottom: 6px;
}
 
.modal-box h4 {
  color: #007b55;
  margin-top: 10px;
  margin-bottom: 8px;
}
 
.item-row {
  display: flex;
  justify-content: space-between;
  margin: 6px 0;
  color: #444;
  font-size: 14px;
}
 
.take-home {
  text-align: center;
  margin-top: 15px;
  font-weight: bold;
  color: #007b55;
  background: #e9f6f1;
  padding: 10px;
  border-radius: 8px;
}
.employee-row{
   display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-bottom: 4px;
}


.employee-value {
  text-align: right;
  font-weight: 500;
}
 
/* === Payslip Template (A4 layout) === */
.payslip-template {
  background: linear-gradient(
    to top,
    rgba(193, 223, 196, 0) 0%,
    rgba(238, 248, 238, 0.9647) 100%
  );
  color: #000;
  width: 700px;
  /* height:700px; */
  padding: 7px 25px;
  font-family: "Calibri", sans-serif;
  border-radius: 8px;
  margin: 0 auto; 
  align-self: flex-start; 
  box-sizing: border-box;
}
 
 
/* .payslip-header {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  border-bottom: 2px solid #000;
  padding-bottom: 10px;
} */
/* .payslip-header {
  display: flex;
  align-items: center;
  justify-content: space-between; /* ✅ center content horizontally */
  /* gap: 20px; optional: space between multiple details 
  border-bottom: 2px solid #000;
  padding-bottom: 10px;
} */
.payslip-header {
  position: relative;
  text-align: center;
  padding: 20px 0;
  border-bottom: 2px solid #000;
}
.employee-data{
  font-size: 12px;
  width:48%;
}
.company-logo {
  position: absolute;
  left: 20px;
  top: 7px;
  width: 80px;
  height: auto;
}

.company-details h2 {
  margin: 0;
}

.company-details p {
  margin: 5px 0 0 0;
}

 /* .payslip-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
} */

/* .header-left {
  display: flex;
  align-items: center;
}

.company-logo {
  width: 80px;   /* adjust size 
  height: auto;
  object-fit: contain;
  margin-right: 15px;
} */

.company-details h2 {
  margin: 0;
  font-size: 20px;
}
 
.company-details p {
  text-align: center;
  margin: 4px 0;
  font-size: 13px;
}
 
.payslip-title2 {
  text-align: center;
  font-size: 18px;
  margin: 10px 0;
  text-decoration: underline;
}
 
.employee-info {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-bottom: 10px;
  
}
 
.earnings-deductions {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
 
.earnings,
.deductions {
  width: 48%;
}
 
.earnings h4,
.deductions h4 {
  border-bottom: 1px solid #000;
  margin-bottom: 6px;
}
 
.earnings p,
.deductions p {
  display: flex;
  justify-content: space-between;
  margin: 3px 0;
}
 
.total-line {
  border-top: 1px solid #000;
  margin-top: 6px;
  padding-top: 6px;
  font-weight: bold;
}
 
.footer-section {
  margin-top: 15px;
  font-size: 12px;
}
.footer-section p{
  font-size: 12px;
}
.note {
  font-size: 12px;
  text-align: center;
  margin-top: 15px;
  color: #444;
}
.material-icons-outlined {
  font-size: 22px;
  color: #84c7ae;
  vertical-align: middle;
  cursor: pointer;
  transition: 0.2s ease;
}
 
.material-icons-outlined:hover {
  color: #84c7ae;
  transform: scale(1.1);
}
 .employee-data-co{
  padding-bottom:1px;
  width:48%
 }
 .salary-table {
  width: 100%;
  /* border: 1px solid #ccc; */
  margin-top: 20px;
  font-size: 12px;
  border-collapse: collapse;
  border:1px solid black;
}
.table-header-ps{
  border-bottom: 1px solid black;
}

.table-header-ps,
.table-row-ps,
.table-footer-ps {
  display: grid;
  grid-template-columns: 2fr 1fr 2fr 1fr;
  /* border-bottom: 1px solid #ddd; */
}

.table-header-ps {
  background-color: #f2f2f2;
  font-weight: bold;
  padding: 8px 0;
}

.table-row-ps {
  padding: 0.5px 0;
}
.table-row-ps-last{

  display: grid;
  grid-template-columns: 2fr 1fr 2fr 1fr;
  padding: 4px 0;
  border-top: 1px solid black;
}
/* .table-row-ps:nth-child(even) {
  background-color: #fafafa;
} */

.table-footer-ps {
  background-color: #f5f5f5;
  padding: 8px 0;
  font-weight: bold;
}
.table-header-cat-ps{
   display: grid;
  grid-template-columns: 2fr 2fr ;
   background-color: #f2f2f2;
  font-weight: bold;
  
  
}
.col-ps {
  padding: 2px 12px;
}
.col-cat-ps{
justify-content: center;
align-items: center;
text-align:center;
border: 1px solid black;
}
.amount {
  text-align: right;
  padding: 4px 12px;
  font-weight: 500;
}
.net-pay-words{
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/UserPayslip/UserPayslip.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB,EAAE,oBAAoB;EACtC,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,eAAe;EACxC,aAAa;EACb,gBAAgB,EAAE,6BAA6B;EAC/C,kBAAkB,EAAE,oBAAoB;EACxC,wCAAwC,EAAE,kBAAkB;AAC9D;AACA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;IACX,YAAY;IACZ,eAAe;AACnB;;;AAGA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,eAAe;IACb,SAAS;IACT,UAAU;EACZ;kBACgB;EAChB,uBAAuB;EACvB,aAAa;EACb,uBAAuB,EAAE,0BAA0B;EACnD,mBAAmB,EAAE,wBAAwB;EAC7C,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,wBAAwB;EACxB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;AACA;GACG,aAAa;EACd,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;;;AAGA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE;;;;GAIC;EACD,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,sBAAsB;AACxB;;;AAGA;;;;;;GAMG;AACH;;;oEAGoE;EAClE;;;GAGC;AACH;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;CAEC;;;;GAIE;;AAEH;;;;;;;;;;GAUG;;AAEH;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;;AAErB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;CACC;EACC,kBAAkB;EAClB;CACD;CACA;EACC,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,8BAA8B;AAChC;;AAEA;;;EAGE,aAAa;EACb,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,sCAAsC;EACtC,cAAc;EACd,2BAA2B;AAC7B;AACA;;GAEG;;AAEH;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;AACA;GACG,aAAa;EACd,+BAA+B;GAC9B,yBAAyB;EAC1B,iBAAiB;;;AAGnB;AACA;EACE,iBAAiB;AACnB;AACA;AACA,uBAAuB;AACvB,mBAAmB;AACnB,iBAAiB;AACjB,uBAAuB;AACvB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["/* === UserPayslip.css === */\n \n.payslip-container {\n  padding: 20px;\n  font-family: \"Poppins\", sans-serif;\n  background: #f8f9fa;\n  min-height: 100vh;\n}\n \n.payslip-title {\n  text-align: center;\n  margin-bottom: 20px;\n  color: #004c3f;\n  font-weight: 600;\n}\n\n.user-payslip-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.user-payslip-header .payslip-title {\n  margin: 0;\n}\n\n.download-all-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 38px;\n  padding: 8px 14px;\n  border: none;\n  border-radius: 6px;\n  background: rgb(132, 199, 174);\n  color: #ffffff;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.download-all-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n.payslip-label {\n  font-size: 16px;\n  font-weight: 500;\n  color: #333;\n  margin-right: 10px;\n}\n\n.payslip-label-select {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.payslip-select {\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  background: white;\n  outline: none;\n  cursor: pointer;\n  transition: 0.2s ease;\n}\n \n.payslip-select:hover {\n  border-color: #007b55;\n}\n \n.month-list {\n  height: 370px; \n  width: 350px;  \n  margin-top: 15px;\n  overflow-y: auto; /* vertical scroll */\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start; /* left align */\n  padding: 10px;\n  background: #fff; /* optional: box background */\n  border-radius: 6px; /* rounded corners */\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1); /* subtle shadow */\n}\n.month-list::-webkit-scrollbar {\n  display: none;\n}\n \n.month-row {\n  width: 300px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 6px;\n  border-bottom: 1px solid #e0e0e0;\n  background: #fff;\n  border-radius: 6px;\n  margin-bottom: 6px;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n \n.month-row:hover {\n  background: #e9f6f1;\n}\n \n.month-name {\n  font-weight: 600;\n  color: #222;\n}\n \n.salary-amount {\n  color: #666;\n  font-size: 14px;\n}\n \n.icon-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n  margin-left: 10px;\n  transition: transform 0.2s ease;\n}\n \n.icon-btn:hover {\n  transform: scale(1.2);\n}\n\n.user-payslip-table-container {\n  width: 100%;\n  overflow-x: auto;\n  background: #fff;\n  border-radius: 6px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n.user-payslip-table {\n  width: 100%;\n  min-width: 780px;\n  border-collapse: collapse;\n}\n\n.user-payslip-table th,\n.user-payslip-table td {\n  border-bottom: 1px solid #e7e7e7;\n  text-align: left;\n  padding: 10px;\n    height: 36px;\n    font-size: 12px;\n}\n\n\n.user-payslip-table th {\n  background: #d8f3d8;\n  /* color: #004c3f; */\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.user-payslip-table td[colspan] {\n  text-align: center;\n  color: #666;\n}\n\n.user-payslip-table .action {\n  white-space: nowrap;\n}\n \n/* === Overlay === */\n.overlay {\n  position: fixed;\n    top: 13vh;\n    left: 38vw;\n  /* width: 100vw;\n  height: 100vh; */\n  background-color: white;\n  display: flex;\n  justify-content: center; /* ✅ center horizontally */\n  align-items: center; /* ✅ center vertically */\n  z-index: 99;\n  padding: 10px;\n}\n\n.payslip-hidden-capture {\n  position: fixed;\n  top: 0;\n  left: -10000px;\n  width: 760px;\n  background: #fff;\n  pointer-events: none;\n}\n\n.payslip-capture-wrapper {\n  background: #fff;\n}\n \n/* === Modal === */\n.modal-box {\n  background: #fff;\n  /* padding: 25px; */\n  border-radius: 12px;\n  /* width: 420px; */\n  position: relative;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n  animation: fadeIn 0.3s ease;\n}\n \n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n \n.close-btn {\n  /* position: absolute; */\n  top: 8px;\n  right: 12px;\n  cursor: pointer;\n  border: none;\n  background: none;\n  font-size: 18px;\n  color: #333;\n  transition: 0.2s ease;\n}\n \n.close-btn:hover {\n  color: #d00000;\n}\n \n.modal-box h3 {\n  text-align: center;\n  color: #004c3f;\n  margin-bottom: 6px;\n}\n \n.modal-box h4 {\n  color: #007b55;\n  margin-top: 10px;\n  margin-bottom: 8px;\n}\n \n.item-row {\n  display: flex;\n  justify-content: space-between;\n  margin: 6px 0;\n  color: #444;\n  font-size: 14px;\n}\n \n.take-home {\n  text-align: center;\n  margin-top: 15px;\n  font-weight: bold;\n  color: #007b55;\n  background: #e9f6f1;\n  padding: 10px;\n  border-radius: 8px;\n}\n.employee-row{\n   display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  margin-bottom: 4px;\n}\n\n\n.employee-value {\n  text-align: right;\n  font-weight: 500;\n}\n \n/* === Payslip Template (A4 layout) === */\n.payslip-template {\n  background: linear-gradient(\n    to top,\n    rgba(193, 223, 196, 0) 0%,\n    rgba(238, 248, 238, 0.9647) 100%\n  );\n  color: #000;\n  width: 700px;\n  /* height:700px; */\n  padding: 7px 25px;\n  font-family: \"Calibri\", sans-serif;\n  border-radius: 8px;\n  margin: 0 auto; \n  align-self: flex-start; \n  box-sizing: border-box;\n}\n \n \n/* .payslip-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  border-bottom: 2px solid #000;\n  padding-bottom: 10px;\n} */\n/* .payslip-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between; /* ✅ center content horizontally */\n  /* gap: 20px; optional: space between multiple details \n  border-bottom: 2px solid #000;\n  padding-bottom: 10px;\n} */\n.payslip-header {\n  position: relative;\n  text-align: center;\n  padding: 20px 0;\n  border-bottom: 2px solid #000;\n}\n.employee-data{\n  font-size: 12px;\n  width:48%;\n}\n.company-logo {\n  position: absolute;\n  left: 20px;\n  top: 7px;\n  width: 80px;\n  height: auto;\n}\n\n.company-details h2 {\n  margin: 0;\n}\n\n.company-details p {\n  margin: 5px 0 0 0;\n}\n\n /* .payslip-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n} */\n\n/* .header-left {\n  display: flex;\n  align-items: center;\n}\n\n.company-logo {\n  width: 80px;   /* adjust size \n  height: auto;\n  object-fit: contain;\n  margin-right: 15px;\n} */\n\n.company-details h2 {\n  margin: 0;\n  font-size: 20px;\n}\n \n.company-details p {\n  text-align: center;\n  margin: 4px 0;\n  font-size: 13px;\n}\n \n.payslip-title2 {\n  text-align: center;\n  font-size: 18px;\n  margin: 10px 0;\n  text-decoration: underline;\n}\n \n.employee-info {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  margin-bottom: 10px;\n  \n}\n \n.earnings-deductions {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n \n.earnings,\n.deductions {\n  width: 48%;\n}\n \n.earnings h4,\n.deductions h4 {\n  border-bottom: 1px solid #000;\n  margin-bottom: 6px;\n}\n \n.earnings p,\n.deductions p {\n  display: flex;\n  justify-content: space-between;\n  margin: 3px 0;\n}\n \n.total-line {\n  border-top: 1px solid #000;\n  margin-top: 6px;\n  padding-top: 6px;\n  font-weight: bold;\n}\n \n.footer-section {\n  margin-top: 15px;\n  font-size: 12px;\n}\n.footer-section p{\n  font-size: 12px;\n}\n.note {\n  font-size: 12px;\n  text-align: center;\n  margin-top: 15px;\n  color: #444;\n}\n.material-icons-outlined {\n  font-size: 22px;\n  color: #84c7ae;\n  vertical-align: middle;\n  cursor: pointer;\n  transition: 0.2s ease;\n}\n \n.material-icons-outlined:hover {\n  color: #84c7ae;\n  transform: scale(1.1);\n}\n .employee-data-co{\n  padding-bottom:1px;\n  width:48%\n }\n .salary-table {\n  width: 100%;\n  /* border: 1px solid #ccc; */\n  margin-top: 20px;\n  font-size: 12px;\n  border-collapse: collapse;\n  border:1px solid black;\n}\n.table-header-ps{\n  border-bottom: 1px solid black;\n}\n\n.table-header-ps,\n.table-row-ps,\n.table-footer-ps {\n  display: grid;\n  grid-template-columns: 2fr 1fr 2fr 1fr;\n  /* border-bottom: 1px solid #ddd; */\n}\n\n.table-header-ps {\n  background-color: #f2f2f2;\n  font-weight: bold;\n  padding: 8px 0;\n}\n\n.table-row-ps {\n  padding: 0.5px 0;\n}\n.table-row-ps-last{\n\n  display: grid;\n  grid-template-columns: 2fr 1fr 2fr 1fr;\n  padding: 4px 0;\n  border-top: 1px solid black;\n}\n/* .table-row-ps:nth-child(even) {\n  background-color: #fafafa;\n} */\n\n.table-footer-ps {\n  background-color: #f5f5f5;\n  padding: 8px 0;\n  font-weight: bold;\n}\n.table-header-cat-ps{\n   display: grid;\n  grid-template-columns: 2fr 2fr ;\n   background-color: #f2f2f2;\n  font-weight: bold;\n  \n  \n}\n.col-ps {\n  padding: 2px 12px;\n}\n.col-cat-ps{\njustify-content: center;\nalign-items: center;\ntext-align:center;\nborder: 1px solid black;\n}\n.amount {\n  text-align: right;\n  padding: 4px 12px;\n  font-weight: 500;\n}\n.net-pay-words{\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
